import React from 'react';
import { useNavigate } from 'react-router-dom';
import PageBreadcrumb from './PageBreadCrumb';
import ComponentCard from './ComponentCard';
import PageMeta from './PageMeta';

interface AccessDeniedProps {
  resourceName: string;
  title?: string;
}

const AccessDenied: React.FC<AccessDeniedProps> = ({ resourceName, title }) => {
  const navigate = useNavigate();

  return (
    <div className="p-6">
      <PageMeta title={title || `${resourceName} - Access Denied`} description={`Access denied for ${resourceName}`} />
      <PageBreadcrumb pageTitle={resourceName} />
      <ComponentCard title="Access Denied">
        <div className="text-center py-12">
          <div className="mb-4">
            <svg
              className="mx-auto h-16 w-16 text-gray-400"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              aria-hidden="true"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              />
            </svg>
          </div>
          <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2" style={{ fontFamily: 'Playfair Display, serif' }}>
            Access Denied
          </h3>
          <p className="text-gray-600 dark:text-gray-400 mb-6" style={{ fontFamily: 'Lato, sans-serif' }}>
            You don't have permission to access {resourceName}. Please contact your administrator if you need access to this section.
          </p>
          <button
            onClick={() => navigate('/')}
            className="px-6 py-2 bg-[#B8860B] text-white rounded-lg hover:bg-[#9A7209] transition-colors font-medium"
            style={{ fontFamily: 'Lato, sans-serif' }}
          >
            Go to Dashboard
          </button>
        </div>
      </ComponentCard>
    </div>
  );
};

export default AccessDenied;

